import axios from "axios";
import { paramsHelper } from "../utils/jwtHelper";

export const getGCmembershipList = (data: any) => {
  try {
    let paramsData = {
      ...data
  }
    let params = paramsHelper(paramsData)
    return axios
      .get(`/stripe/galaxyClubMembership` + params)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  } catch (error) {
    throw error;
  }
};
